export default __webpack_public_path__ + "static/media/languageIcon.25848722.svg";